<template>
  <div class="advice common_bg">
    <img-preview v-if="preImgUrl" :url="preImgUrl" @close="preImgUrl=''"/>
    <div class="title">问题反馈</div>
    <div class="main">
      <advice-success />
      <p class="btns">
        <i>问题描述:</i>
        <span
          :class="{'focus':clickItem==item.type}"
          v-for="(item,index) in btns"
          :key="index"
          @click="btnsclick(item.type)"
        >{{item.des}}</span>
      </p>
      <p class="textareaBox">
        <textarea
          @keydown="keydown"
          @focus="hint=''"
          @blur="hint='描述你的问题(4-100字)'"
          :placeholder="hint"
          v-model="sendText"
          maxlength="100"
        ></textarea>
        <span>{{sendText.length}}/100</span>
      </p>
      <div class="upload">
        <p class="desc">
          <i>上传问题截图:</i>
          <span>(每张图片不要超过20M)</span>
        </p>
        <div class="img-container">
          <div class="imgBox" v-for="(item,index) in imgList" :key="index">
            <img :src="item.base64" class="cursor" alt @click="preImgUrl=item.base64">
            <img
              src="../../../assets/img/common/close.png"
              @click="del(index)"
              alt
              class="cursor icon"
            >
          </div>
          <label class="imgBox add cursor" v-if="imgList.length<3" for="file_input"></label>
          <input
            type="file"
            style="display:none"
            id="file_input"
            ref="fileInput"
            multiple
            @change="getFile()"
            accept="image/gif, image/jpeg, image/jpg, image/png"
          >
        </div>
      </div>
      <div class="upload phone">
        <div>
          <p class="desc">
            <i>手机号码:</i>
          </p>
          <input type="text" maxlength="13"
          @focus="phoneHint=''"
          @blur="phoneHint='请输入您的手机号'"
          :placeholder="phoneHint"
          v-model="phone">
          <span>请务必填写有效手机号，技术老师会尽快与你联系</span>
        </div>
        <div class="submitBox">
          <button
            class="cursor"
            :class="{'disable':this.clickItem == -1 || !this.sendText || this.sendText.trim().length < 4 || phone.replace(/\s/g, '').length!==11}"
            @click="submit"
          >提交</button>
          <button
            class="cursor"
            @click="goBack"
          >返回</button>
        </div>
      </div>
    </div>
    <div class="resultAlert" v-show="result===2 || result===3">
      <div class="content">
        <div class="img" :class="{'errImg':result===3}"></div>
         <p v-if="result===2">
          提交成功
          <br>技术老师会尽快与您联系
        </p>
        <p v-if="result===3">{{errorText}}</p>
      </div>
    </div>
    <Back @goBack="goBack"/>
    <Toast :showText="toastText" v-if="toastText" @toastCallBack="toastText=''"/>
  </div>
</template>
<script>
import { imgPreview } from "@/js/compress.js";
import Back from "@/components/basic/back.vue";
import Toast from "@/components/basic/toast.vue";
import ImgPreview from "@/components/basic/imgPreview.vue";
import adviceSuccess from "./advice_success.vue";
import common from "common";
import { mapActions,mapMutations,mapState } from "vuex";

export default {
  data() {
    return {
      preImgUrl: "",
      btns: [],
      clickItem: -1,
      imgList: [],
      hint: "描述你的问题(4-100字)",
      phoneHint:'请输入您的手机号',
      sendText: "",
      toastText: "",
      phone:'',
      result: 0, //0默认值 1正在提交 2提交成功 3提交失败
      errorText:'提交失败，请稍后重试'
    };
  },
  computed:{
    ...mapState(['userID'])
  },
  components: {
    Back,
    Toast,
    "img-preview": ImgPreview,
    "advice-success":adviceSuccess
  },
  watch:{
    sendText(val){
      this.sendText = val.replace(/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g,'')
    },
    //手机号 3 4 4 格式
    phone(newValue, oldValue) {
      let val = newValue.replace(/[^0-9]/g, "");
      val = val.length > 11 ? val.substr(0, 11) : val;
      if (newValue.length >= oldValue.length || newValue.length == 11) {
        if (val.replace(/\s/g, "").length < 3) {
          this.phone = val.replace(/\s/g, "");
        } else if (
          val.replace(/\s/g, "").length >= 3 &&
          val.replace(/\s/g, "").length < 7
        ) {
          this.phone = val.replace(/\s/g, "").replace(/(\d{3})/, "$1 ");
        } else if (val.replace(/\s/g, "").length >= 7) {
          this.phone = val
            .replace(/\s/g, "")
            .replace(/(\d{3})(\d{4})/, "$1 $2 ");
        }
      } else {
        this.phone = this.phone.trim();
      }
    }
  },
  created(){
    this.getList();
  },
  methods: {
    ...mapActions(["problemFeedback","getBugTyptList"]),
    ...mapMutations([ "refreshNet"]),
    getList(){
      const from = this.$route.query.from;
      let data = {
        problem_type:from === "update" || from === "login" ?"install_error":'',
        client_type:common.device
      }
       this.getBugTyptList(data).then(({ res, ok }) => {
          if (!ok)return;
          let data = res.find((item)=>{
            return item.checked == 1;
          }) || {};
          this.clickItem = data.type || -1;
          this.btns = res;
       })
    },
    btnsclick(index) {
      this.clickItem = this.clickItem == -1 || this.clickItem != index ? index : -1;
    },
    goBack() {
      const from = this.$route.query.from;
      if (from === "video" || from === "login") {
        this.$router.go(-1);
        return;
      }
      if(from === "update"){
        this.$router.push({
          name:"class",
          params:{
            from:"first"
          }
        });
        return;
      }
      this.$router.push("/userinfo");
    },
    async getFile(id) {
      let files = this.$refs.fileInput.files;
      let filesLen = files.length + this.imgList.length;
      let len = 3 - filesLen;
      if (filesLen > 3) {
        files = Array.prototype.slice.apply(files, [0, len]);
      }
      for (let i = 0; i < files.length; i++) {
        if (files[i].size > 20 * 1024 * 1024) {
          //图片不能大于20M
          this.toastText = "图片太大了，请重新选择";
          continue;
        }
        this.imgList.push(await imgPreview(files[i]));
        // console.log(this.imgList)
      }
      this.$refs.fileInput.value = null;
    },
    del(index) {
      this.imgList.splice(index, 1);
    },
    getCursortPosition(ctrl) {
      var CaretPos = 0; // IE
      if (document.selection) {
        ctrl.focus();
        var Sel = document.selection.createRange();
        Sel.moveStart("character", -ctrl.value.length);
        CaretPos = Sel.text.length;
      }
      // 兼容傻逼火狐
      else if (ctrl.selectionStart || ctrl.selectionStart == "0")
        CaretPos = ctrl.selectionStart;
      return CaretPos;
    },
    keydown(event) {
      var e = event || window.event || arguments.callee.caller.arguments[0];
      if (e && e.keyCode == 13) {
        let pointer = this.getCursortPosition(this.$refs.fileInput);
        if (this.sendText == "" ||  this.sendText.substr(pointer - 1, 1).search(/\n/g) != -1) {
          event.cancelBubble = true;
          event.preventDefault();
          event.stopPropagation();
        }
      }
    },
    hideResultAlert() {
      setTimeout(() => {
        this.result === 2 && this.goBack();
        this.result = 0;
      }, 3000);
    },
    submit() {
      if (!navigator.onLine) {
        this.refreshNet(false);
        return;
      }
      if (this.result !== 0) return;
      var formData = new FormData();
      this.result = 1;
      formData.append("bug_type", this.clickItem);
      formData.append("content", this.sendText);
      formData.append("client_type", common.device);
      formData.append("phone", this.phone.replace(/\s/g, ''));
      this.imgList.forEach(v => {
        formData.append("image[]", v.file);
      });
      // console.log(formData)
      this.problemFeedback(formData)
        .then(({ ok, res }) => {
          if (!ok) {
            switch(res.code){
              case "E_FAILED":
                this.errorText =  res.desc;
                break;
              case "E_PHONE":
                this.errorText = '提交失败，请填写真实的手机号码';
                break;
              default:
                this.errorText = '提交失败，请稍后重试';
            }
            // this.errorText = res.code === 'E_PHONE' ? '提交失败，请填写真实的手机号码':'提交失败，请稍后重试';
            this.result = 3;
            this.hideResultAlert();
            this.$root.eventHub.$emit("createLog", {
              id: "LMTrackEventFbResult",
              data: {
                result: 2
              }
            });
            return;
          }
          this.result = 2;
          this.hideResultAlert();
          common.set("advice_success_info",{
            uid:this.userID,
            time:Date.now()+(1000*60*3)//三分钟有效
          })
          this.$root.eventHub.$emit("createLog", {
            id: "LMTrackEventFbResult",
            data: {
              result: 1
            }
          });
        })
        .catch(e => {
          this.$root.eventHub.$emit("createLog", {
            id: "LMTrackEventFbResult",
            data: {
              result: 2
            }
          });
          this.errorText = '提交失败，请稍后重试';
          this.result = 3;
          this.hideResultAlert();
        });
    }
  }
};
</script>
<style lang="less" scoped>
@bg-color: #0085c9;
::-webkit-scrollbar {
  width: 0px;
}
.advice {
  overflow-y: scroll;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  .title {
    color: #ffffff;
    font-size: 26px;
    text-align: center;
    height: 80px;
    font-weight: 600;
    line-height: 80px;
  }

  .main {
    position: relative;
    width: 1024px;
    background: #fff;
    border-radius: 20px;
    min-height: 670px;
    max-height: 80%;
    height: 100%;
    margin: 20px auto;
    padding: 60px 45px 0px 45px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    .btns {
      text-align: left;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-wrap: wrap;
      margin-bottom: 15px;
      width: 100%;
      i {
        display: block;
        word-break: keep-all;
        font-size: 22px;
        color: #333;
        font-weight: 700;
        margin-right: 15px;
        height: 45px;
        line-height: 45px;
        margin-bottom: 20px;
      }
      span {
        word-break: keep-all;
        color: #0073ae;
        // width: 120px;
        padding: 0 17px;
        display: block;
        height: 45px;
        text-align: center;
        line-height: 45px;
        font-size: 18px;
        border-radius: 9px;
        border: 1px solid @bg-color;
        margin: 0 13px 20px;
        cursor: pointer;
      }
      .focus {
        background: @bg-color;
        color: #ffffff;
      }
    }
    .textareaBox {
      border: 1px solid rgba(228, 228, 228, 1);
      height: 155px;
      min-height: 120px;
      margin-bottom: 30px;
      width: 100%;
      padding: 10px 10px 10px 20px;
      position: relative;
      border-radius: 6px;
      span {
        position: absolute;
        right: 20px;
        bottom: 10px;
        color: #999;
        font-size: 18px;
      }
      textarea::-webkit-input-placeholder {
        color: #999999;
      }
      textarea {
        height: 100%;
        width: 100%;
        resize: none;
        color: #666;
        font-size: 19px;
        text-align: left;
        line-height: 1.6;
        &::-webkit-scrollbar {
          width: 6px;
        }
        &::-webkit-scrollbar-thumb {
          /*滚动条里面小方块*/
          border-radius: 6px;
          box-shadow: inset 0 0 5px #d7d7d7;
          background: #d7d7d7;
          //   -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        }
        &::-webkit-scrollbar-track {
          /*滚动条里面轨道*/
          background: #f1f3f4;
          // -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        }
      }
    }
    .upload {
      width: 100%;
      text-align: left;
      .desc {
        i{
          font-size: 22px;
          font-weight:700;
        }
        span {
          color: #999999;
        }
        margin-bottom: 25px;
      }
      .img-bg {
        img {
          height: 87px;
          width: 87px;
        }
      }
      .img-container {
        display: flex;
        align-items: center;

        .imgBox {
          height: 87px;
          width: 87px;
          margin-right: 20px;
          border-radius: 6px;
          position: relative;
          img {
            height: 100%;
            width: 100%;
            border-radius: 6px;
          }
          .icon {
            width: 25px;
            height: 25px;
            position: absolute;
            right: -12px;
            top: -12px;
          }
        }
        .add {
          border: 1px solid rgba(228, 228, 228, 1);
          background: url("../../../assets/img/common/add.png") no-repeat center;
          background-size: 26px;
        }
      }
    }
    .phone{
      margin-top: 30px;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      padding-bottom: 50px;
      min-height: 162px;
      box-sizing: content-box;
      input{
        width: 370px;
        height: 60px;
        border: 1px solid #E4E4E4;
        border-radius: 6px;
        margin-bottom: 15px;
        padding-left: 20px;
        font-size: 20px;
        color: #333;
      }
      input::-webkit-outer-spin-button, input::-webkit-inner-spin-button { -webkit-appearance: none; }
      input[type="number"]{ -moz-appearance: textfield; }
      input::-webkit-input-placeholder {
        color: #999999;
      }
      span{
        display: block;
        color: #D14A4A;
      }
    }
    .submitBox {
      height: 100%;
      display: flex;
      align-items: center;
      button {
        width: 170px;
        height: 60px;
        line-height: 60px;
        min-height: 60px;
        border-radius: 12px;
        font-size: 27px;
        margin-left:30px;
        &:first-child{
          background: #008acf;
          color: #fff;
        }
        &:first-child:hover {
          color: #fff;
          background: #4cadde;
        }
        &:last-child{
          border:2px solid #0073ae;
          background:#fff;
          color: #0073AE;
        }
        &:last-child:hover {
          border:2px solid #006581;
          background:#fff;
          color: #006581;
        }
        &.disable {
          background: #008acf;
          color: #bfdde5;
          opacity: 0.6;
          pointer-events: none;
        }
      }

    }
  }
}
.resultAlert {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 999;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.7);
  .content {
    width: 410px;
    background: #ffffff;
    border-radius: 15px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .img {
      height: 82px;
      margin: 50px 0 20px 0;
      background: url(../../../assets/img/common/success.png) no-repeat center
        center;
      background-size: 82px;
    }
    .errImg {
      background: url(../../../assets/img/common/error.png) no-repeat center
        center;
      background-size: 82px;
    }
    p {
      font-size: 24px;
      font-weight: 500;
      color: #333333;
      padding-bottom: 50px;
    }
  }
}
@media screen and(max-height:670px) {
  .advice .title {
    height: 60px;
    line-height: 80px;
  }
  .advice .main {
    padding-top: 40px;
    min-height: 600px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/advice/advice.vue